import React from "react";
import AlertModal from "./Modal";
import Input from "./Input";
import OtpInput from "react-otp-input";
import PrimaryTheme from "../Themes/Primary";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./withdrawComission.scss";
import CashoutAccount from "./CashoutAccount";
import { Reducers } from "../Interfaces/Interfaces";
import SetUpCashoutAccount from "./SetUpCashoutAccount";
import CreatePIN from "./CreatePin";
import Banner from "./Banner";
import {
    getAggregatorDetails,
    getCashoutAccount,
    getUserDetails,
    verifyUserOtp,
    withdrawToBank,
    withdrawToWallet,
} from "../redux/actions/userActions";
import {
    getAdminUser,
    getCoordinatorCashoutAccount,
    withdrawToBankCoordinator,
    withdrawWalletCoordinator,
} from "../redux/actions/CoordinatorActions";
import WithdrawalAuthentication from "./withdrawalAuthentication";
import { requestIdGenerator } from "../helpers/Functions";
import WithdrawalLoader from "./withdrawalLoader";
import { Tooltip, Button, withStyles } from "@material-ui/core";

export default function WithdrawCommissionsAlertPopup(props: any) {
    console.log(props);

    const userType = useSelector((state: Reducers) => state.userType);
    const user = useSelector((state: Reducers) => state.user);
    const tokens = useSelector((state: Reducers) => state.tokens);
    const verifyOtp = useSelector((state: Reducers) => state.verifyOtp);
    const alert = useSelector((state: Reducers) => state.alert);

    const dispatch = useDispatch();
    const history = useHistory();

    const cashout = useSelector((state: Reducers) => state.cashout);

    const setupCashout = () => {
        dispatch({
            type: "ALERT_MODAL",
            payload: false,
        });

        history.push("/settings-and-support");
    };

    const handleOtpSubmit = () => {
        props.setSubmittedOtp(true);
        const data = {
            validatedEntityId: props.validatedEntityId,
            otp: props.authenticationOtp,
        };
        dispatch(verifyUserOtp(data));
    };
    // Custom styles for the tooltip
    const CustomTooltip = withStyles((theme) => ({
        tooltip: {
            fontSize: "14px",
            padding: "10px",
            maxWidth: "300px",
        },
    }))(Tooltip);

    React.useEffect(() => {
        if (verifyOtp && Object.entries(verifyOtp).length !== 0) {
            if (verifyOtp.message == "OTP verified successfully") {
                if (props.isBank) {
                    const data = {
                        accountName: props.accountName,
                        accountNumber: cashout.accountNumber,
                        bankCode: cashout.bankCode,
                        bankName: cashout.bankName,
                        amountToSend: props.amount,
                        phoneNumber: cashout.phoneNumber,
                        sendersPhoneNumber: user.phoneNumber,
                        otp: props.pin,
                        clientRequestId: requestIdGenerator(),
                        channel: "1",
                    };
                    if (props.isCommission) {
                        dispatch(withdrawToBank(data));
                    } else if (props.isCordinator) {
                        if (userType === "5") {
                            dispatch(withdrawToBank(data));
                        } else {
                            dispatch(withdrawToBankCoordinator(data));
                        }
                    } else if (props.isTransaction) {
                        if (userType === "5") {
                            dispatch(withdrawToBank(data));
                        } else {
                            dispatch(withdrawToBankCoordinator(data));
                        }
                    } else {
                        dispatch(withdrawToBank(data));
                    }
                } else {
                    const data = {
                        amount: props.amount,
                        recipientAccount: props.walletAccount,
                        otp: props.pin,
                        clientRequestId: requestIdGenerator(),
                        channels: "1",
                    };
                    const dataForCordinatorWallet = {
                        amount: props.amount,
                        recipientAccount: props.walletAccount,
                        pin: props.pin,
                        clientRequestId: requestIdGenerator(),
                        channels: "1",
                    };
                    if (props.isCommission) {
                        dispatch(withdrawToWallet(data));
                    } else if (props.isCordinator) {
                        if (userType === "5") {
                            dispatch(withdrawToWallet(data));
                        } else {
                            dispatch(withdrawWalletCoordinator(dataForCordinatorWallet));
                        }
                    } else if (props.isTransaction) {
                        if (userType === "5") {
                            dispatch(withdrawToWallet(data));
                        } else {
                            dispatch(withdrawWalletCoordinator(dataForCordinatorWallet));
                        }
                    } else {
                        dispatch(withdrawToWallet(data));
                    }
                }
            }
        }
    }, [verifyOtp, dispatch]);

    React.useEffect(() => {
        // if (userType === '5') {

        //   dispatch(getUserDetails(user.phoneNumber));
        //   dispatch(getCashoutAccount(user.id));
        //   dispatch(getAggregatorDetails(user.id));

        // }
        // else {

        //   dispatch(getAdminUser(tokens.access_token));
        //   dispatch(getCoordinatorCashoutAccount(user.id));
        // }

        dispatch(getCashoutAccount(user.id));
        dispatch(getAggregatorDetails(user.id));
        dispatch({
            type: "LOADING",
            payload: true,
        });
        // if(user.isTransactionPinSet){
        //     console.log("working")
        //     dispatch({type:"GET_IF_PIN_IS_SET",payload:true})
        // }else{
        //  console.log("working")

        //  dispatch({type:"GET_IF_PIN_IS_SET",payload:false})
        // }
        return () => {
            dispatch({
                type: "CASHOUT",
                payload: {},
            });
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    return (
        <AlertModal showClose>
            {props.NewCashout && !props.authenticate ? (
                <React.Fragment>
                    {props.hasCashout && !props.authenticate ? (
                        <div className="col-md-12 p-5 text-center comission__modal__cover">
                            <div className="col-md-12 ">
                                <span
                                    className="badge-pill p-3 d-block col-md-7 col-12 ml-auto mr-auto withdraw-comission-header"
                                    style={{
                                        background: PrimaryTheme.warn,
                                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    }}
                                >
                                    WITHDRAW COMMISSIONS
                                </span>
                            </div>

                            <div className="form-group mt-4 text-left">
                                <label
                                    style={{
                                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                                        color: PrimaryTheme.dark,
                                    }}
                                >
                                    Withdraw To:{" "}
                                </label>

                                <div className="input-group mb-3 col-md-12 ml-auto mr-auto">
                                    <div className="input-group-prepend w-50">
                                        {/* <button
                      disabled={true}
                      className={
                        props.account === "wallet"
                          ? "btn btn-success w-100 btn-lg"
                          : "w-100 btn-light border"
                      }
                      type="button"
                      style={{
                        borderRadius: "20px 0 0 20px",
                      }}
                      onClick={() => props.setAccount("wallet")}
                    >
                      Wallet
                    </button> */}
                                        {/* Wallet button with Material-UI Tooltip */}
                                        <CustomTooltip
                                            title="Kindly withdraw through bank route"
                                            arrow
                                            placement="top"
                                        >
                                            <span className="w-100">
                                                <button
                                                    disabled={true}
                                                    className={
                                                        props.account === "wallet"
                                                            ? "btn btn-success w-100 h-100 btn-lg custom-button"
                                                            : "w-100 h-100 btn-light border custom-button"
                                                    }
                                                    style={{
                                                        borderRadius: " 20px 0 0 20px",
                                                        cursor: "not-allowed",
                                                    }}
                                                    onClick={() => props.setAccount("wallet")}
                                                >
                                                    Wallet
                                                </button>
                                            </span>
                                        </CustomTooltip>
                                    </div>

                                    <div className="input-group-append w-50">
                                        <button
                                            className={
                                                props.account === "bank"
                                                    ? "btn btn-success w-100 btn-lg"
                                                    : "w-100 btn-light border"
                                            }
                                            type="button"
                                            style={{
                                                borderRadius: "0 20px 20px 0",
                                            }}
                                            onClick={() => props.setAccount("bank")}
                                        >
                                            Bank
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {props.account === "wallet" && (
                                <React.Fragment>
                                    <div className="form-group mt-4 text-left">
                                        <label
                                            htmlFor="walletAccount"
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                color: PrimaryTheme.dark,
                                            }}
                                        >
                                            Cashout Wallet
                                        </label>
                                        <Input
                                            type="tel"
                                            placeholder="Cashout Wallet"
                                            autoComplete="text"
                                            showIcon
                                            required
                                            id="walletAccount"
                                            value={props.walletAccount}
                                            disabled
                                            inputMode="tel"
                                            onChange={(e) => props.setWalletAccount(e.target.value)}
                                            isInput
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC",
                                            }}
                                        />
                                    </div>

                                    <div className="form-group mt-4 text-left">
                                        <label
                                            htmlFor="agentName"
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                color: PrimaryTheme.dark,
                                            }}
                                        >
                                            Agent Name
                                        </label>
                                        <Input
                                            type="tel"
                                            placeholder="Agent Name"
                                            autoComplete="agentName"
                                            showIcon
                                            required
                                            id="agentName"
                                            value={props.agentName}
                                            disabled
                                            inputMode="text"
                                            onChange={(e) => props.setAgentName(e.target.value)}
                                            isInput
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC",
                                            }}
                                        />
                                    </div>
                                </React.Fragment>
                            )}

                            {props.account === "bank" && (
                                <React.Fragment>
                                    <div>
                                        <div className="form-group mt-4 text-left">
                                            <label
                                                htmlFor="cashoutAccount"
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                    color: PrimaryTheme.dark,
                                                }}
                                            >
                                                Cashout Account
                                            </label>
                                            <Input
                                                type="tel"
                                                placeholder="Cashout Account"
                                                autoComplete="text"
                                                showIcon
                                                required
                                                id="cashoutAccount"
                                                value={
                                                    props.cashoutAccount === "null (null)"
                                                        ? ""
                                                        : props.cashoutAccount
                                                }
                                                disabled
                                                inputMode="tel"
                                                onChange={(e) => props.setWalletAccount(e.target.value)}
                                                isInput
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC",
                                                }}
                                            />
                                        </div>

                                        <div className="form-group mt-4 text-left">
                                            <label
                                                htmlFor="accountName"
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                    color: PrimaryTheme.dark,
                                                }}
                                            >
                                                Account Name
                                            </label>
                                            <Input
                                                type="tel"
                                                placeholder="Account Name"
                                                autoComplete="accountName"
                                                showIcon
                                                required
                                                id="accountName"
                                                value={props.accountName}
                                                disabled
                                                inputMode="tel"
                                                onChange={(e) => props.setAccountName(e.target.value)}
                                                isInput
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            <div className="form-group mt-4 text-left">
                                <label
                                    htmlFor="amount"
                                    style={{
                                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                                        color: PrimaryTheme.dark,
                                    }}
                                >
                                    Amount
                                </label>
                                <Input
                                    type="number"
                                    min="0"
                                    placeholder="Amount"
                                    autoComplete="amount"
                                    showIcon
                                    required
                                    id="amount"
                                    value={props.amount}
                                    disabled={props.submitted}
                                    inputMode="tel"
                                    onChange={(e) => props.setAmount(e.target.value)}
                                    isInput
                                    style={{
                                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                                        color: PrimaryTheme.dark,
                                        background: "#F4F7FC",
                                    }}
                                />
                            </div>

                            <div className="row m-0 justify-content-center align-items-center">
                                <OtpInput
                                    value={props.pin}
                                    onChange={(e: any) => props.setPin(e)}
                                    numInputs={4}
                                    isInputNum
                                    shouldAutoFocus
                                    inputStyle={{
                                        width: "45px",
                                        height: "45px",
                                        fontSize: "24px",
                                        padding: 0,
                                        textAlign: "center",
                                        borderRadius: 10,
                                        border: "1px solid",
                                        borderColor: PrimaryTheme.primary,
                                    }}
                                    isInputSecure
                                    separator={<span className="mr-3"> </span>}
                                />
                            </div>

                            <div className="form-group mt-5 mb-0">
                                {props.account === "wallet" && (
                                    <Input
                                        onClick={props.handleSubmit}
                                        type="button"
                                        isInput
                                        disabled={props.pin.length === 0}
                                        value={props.loading ? "Please wait..." : "Continue"}
                                        style={{
                                            background: PrimaryTheme.primary,
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.white,
                                        }}
                                        className="text-bold border-0 col-md-6"
                                    />
                                )}

                                {props.account === "bank" && (
                                    <Input
                                        onClick={props.handleBank}
                                        type="button"
                                        isInput
                                        disabled={props.pin.length === 0}
                                        value={props.loading ? "Please wait..." : "Continue"}
                                        style={{
                                            background: PrimaryTheme.primary,
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.white,
                                        }}
                                        className="text-bold border-0 col-md-6"
                                    />
                                )}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="col-md-12">
                                <span
                                    className="badge-pill p-3 d-block col-7 ml-auto mr-auto mt-4"
                                    style={{
                                        background: PrimaryTheme.warn,
                                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                                        textAlign: "center",
                                    }}
                                >
                                    No Cashout Account
                                </span>
                                <div
                                    style={{
                                        paddingTop: "100px",
                                        paddingBottom: "20px",
                                        textAlign: "center",
                                    }}
                                >
                                    <Input
                                        onClick={setupCashout}
                                        type="button"
                                        isInput
                                        value={"Create Cashout Account"}
                                        style={{
                                            background: PrimaryTheme.primary,
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.white,
                                        }}
                                        className="text-bold border-0 col-md-6"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            ) : (
                <div>
                    {user.isTransactionPinSet && !props.authenticate ? (
                        <CashoutAccount />
                    ) : props.authenticate ? (
                        <WithdrawalAuthentication
                            otp={props.authenticationOtp}
                            setOtp={props.setAuthenticationOtp}
                            handleSubmit={handleOtpSubmit}
                            account={props.account}
                            setAmount={props.setAmount}
                            submitted={props.submittedOtp}
                            title={props.title}
                            subtitle={props.subtitle}
                            handleRefresh={props.handleRefresh}
                            counter={props.counter}
                            setCounter={props.setCounter}
                            handleBank={props.handleBank}
                            setAuthenticate={props.setAuthenticate}
                        />
                    ) : (
                        <div>
                            <div style={{ marginLeft: "20px", marginRight: "20px" }}>
                                <Banner
                                    className="bq-warning"
                                    text={"Create Transaction PIN"}
                                    iconColor={PrimaryTheme.dark}
                                />
                            </div>
                            <CreatePIN />
                        </div>
                    )}
                    {/* {
    user.isTransactionPinSet?<CashoutAccount />:<div><div style={{marginLeft:"20px",marginRight:"20px"}}> <Banner
    className="bq-warning"
    text={ "Create Transaction PIN"}
    iconColor={PrimaryTheme.dark}
  /></div>
<CreatePIN/></div>
} */}
                </div>
            )}
        </AlertModal>
    );
}

interface CashoutProps { }
